export const album = {
  songs: 'songs',
  Album: 'Album',
  'More by': 'More by',
};
